// Share a contact with a teammate: writes a COPY into the teammate's book
// (createdBy = recipient) — like forwarding a contact card. The copy is
// theirs; later edits on either side don't affect the other. Re-sharing the
// same contact to the same person overwrites the earlier copy (idempotent id)
// instead of piling up duplicates.
import {
  addContactToFirebase,
  invalidateContactsCache,
} from "./firebasefunctions";
import { newmessagesuccess } from "./helper";

// Pure: the doc the recipient gets. Strips the sharer's identity/sync fields
// so the copy is a clean, unsynced contact in the recipient's book (their
// next Google sync can pick it up).
export function buildSharedContactDoc(contact, fromUser, toUser, now) {
  const {
    id,
    firebaseId,
    createdBy,
    googleResourceName,
    lastSyncedAt,
    _teamOwnerName,
    ...fields
  } = contact || {};
  return {
    ...fields,
    id: `shared_${id || "contact"}_${toUser?.id || "user"}`,
    createdBy: toUser?.id || "",
    createdAt: now,
    source: "shared",
    sharedFrom: fromUser?.id || "",
    sharedFromName:
      `${fromUser?.firstname || ""} ${fromUser?.lastname || ""}`.trim(),
    originalContactId: id || "",
  };
}

export async function shareContactWithTeammate({ contact, fromUser, toUser }) {
  if (!contact || !toUser?.id) throw new Error("Missing contact or teammate");
  const doc = buildSharedContactDoc(contact, fromUser, toUser, Date.now());
  await addContactToFirebase(doc);
  invalidateContactsCache();
  // Tell the teammate (fire-and-forget; sharing succeeds regardless).
  const contactName =
    contact.name ||
    `${contact.firstName || ""} ${contact.lastName || ""}`.trim() ||
    "A contact";
  const fromName =
    `${fromUser?.firstname || ""} ${fromUser?.lastname || ""}`.trim() ||
    "A teammate";
  newmessagesuccess(
    "Contact shared with you",
    toUser.id,
    `${fromName} shared ${contactName} with you`,
    String(doc.id),
    "contact-shared",
    String(doc.id),
  ).catch(() => {});
  return doc;
}
